import { render, staticRenderFns } from "./template1.vue?vue&type=template&id=09d3194a&scoped=true"
import script from "./template1.vue?vue&type=script&lang=js"
export * from "./template1.vue?vue&type=script&lang=js"
import style0 from "./template1.vue?vue&type=style&index=0&id=09d3194a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d3194a",
  null
  
)

export default component.exports